import React from 'react'

interface Props {
  startDate: Date | string
  endDate: Date | string
  formatDate: (date: Date | string) => string
}

const ProjectDateRange = ({ startDate, endDate, formatDate }: Props) => {
  return (
    <div className="tribe-org__engagement-dates">
      <div>
        <div className="tribe-org__engagement-date-label">SOW Start</div>
        <div className="tribe-org__engagement-date-value">
          {formatDate(startDate)}
        </div>
      </div>
      <div>
        <div className="tribe-org__engagement-date-label">SOW End</div>
        <div className="tribe-org__engagement-date-value">
          {formatDate(endDate)}
        </div>
      </div>
    </div>
  )
}

export default ProjectDateRange
